import React from "react";

const EmailTemplatePreview = ({
  applicationName,
  supportContact,
  uploadedBanner,
}) => {

  return (
    <div className="space-y-5">
      <p className="font-inter font-semibold text-base text-[#1E293B]">
        Example Preview
      </p>
      <div className="w-full h-full relative border border-[#E8E8E8] rounded-xl py-10 px-16 text-center">
        <div className="w-full flex justify-center ">
          <img
            src={
              uploadedBanner
                ? uploadedBanner
                : "https://prod-workflows-performance.s3.ap-southeast-1.amazonaws.com/bd988f5217a0b270103189ffc21bb021.png"
            }
            alt="logo"
          />
        </div>
        <p className="font-inter font-normal text-sm text-[#1E293B] pt-7">
          Welcome to
        </p>
        <p className="font-inter font-bold text-sm text-[#1E293B] pb-7">
          {applicationName ? applicationName : "Shiperone Workflows!"}
        </p>
        <p className="font-inter font-normal text-sm text-[#1E293B]">
          Hi John!
        </p>
        <p className="font-inter font-normal text-sm text-[#1E293B] pb-3">
          We are excited to have you here with us! To login into your account
          please enter the verification code on the login page.
        </p>
        <p className="font-inter font-bold text-base text-[#1E293B] py-4">
          123456
        </p>
        <p className="font-inter font-normal text-sm text-[#1E293B] py-4">
          Note:{" "}
          <span className="font-semibold">
            This code will expire in 10 minutes.
          </span>
        </p>
        <p className="font-inter font-normal text-sm text-[#1E293B]">
          In case you need support feel free to reach out to us under{" "}
          <span className="font-semibold">
            {supportContact ? supportContact : "support@shiperone.com"}
          </span>
        </p>
        <div className="pt-8 font-inter font-normal text-[10px] text-[#535860]">
          Powered by Shiperone
        </div>
      </div>
    </div>
  );
};

export default EmailTemplatePreview;
